/**************************************************
 * Nombre:       Home_Lleva_Tu_Marca
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Galeria_Imagenes from "./Sub_Componentes/Galeria_Imagenes";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Lleva_Tu_Marca = () => {
    const {sCell} = useResponsive()


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#F6F6F6'}}

        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 8}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 0}}>
                    <Typography sx={{
                        color: '#9CAD6C',
                        fontSize: 20,
                        fontWeight: 600,
                        letterSpacing: 6,
                        textAlign: sCell ? 'center' : 'left'
                    }}>LLEVA TU
                        MARCA MAS
                        LEJOS</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'center', mt: 1}}>
                    <Typography sx={{fontSize: 30, fontWeight: 800, textAlign: 'center', lineHeight: 1.2}}>
                        El éxito no es solo cuestión de ideas, sino de ejecución.
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'center', mt: 4}}>
                    <Typography sx={{fontSize: 16, fontWeight: 400, textAlign: 'center'}}>
                        Por eso, trabajo con un equipo de especialistas en cada área, combinando experiencia y
                        conocimiento para alcanzar —y superar— cualquier meta. Juntos, hacemos que las marcas crezcan
                        con estrategias sólidas y resultados reales.
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'center', mt: 10}}>
                    <Galeria_Imagenes/>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Home_Lleva_Tu_Marca